// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2fsgW","ring":"style_ring__3R2Ug","animate":"style_animate__34LYh","animate2":"style_animate2__2oG0b"};